import React, { FC, useEffect, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';
import SCROLLTOP from '../../../app/assets/images/scrollToTop-icon.svg';
import CALL from '../../../app/assets/images/FooterLogos/call.svg';
import EMAIL from '../../../app/assets/images/FooterLogos/email.svg';
import LOCATION from '../../../app/assets/images/FooterLogos/location.svg';
import INSTAGRAM from '../../../app/assets/images/FooterLogos/instagram.svg';
import TWITTER from '../../../app/assets/images/FooterLogos/twitter.svg';
import LINKEDIN from '../../../app/assets/images/FooterLogos/linkedin.svg';
import COPYRIGHT from '../../../app/assets/images/FooterLogos/copyright.svg';
import FooterContactInfo from '../../molecules/FooterContactInfo/FooterContactInfo';
import { getPageData, useData } from '../../../app/helper/functions';
import images from '../../../app/utlis/image';

interface FooterProps {
    footerContactInfo?: any
}

const Footer: FC<FooterProps> = ({ footerContactInfo }) => {
    const [link, setLink] = useState(false);
    const [services, setServices] = useState(false);
    const [ismobile, setIsmobile] = useState(window.innerWidth < 768);
    const controls = useAnimation();

    const { loading, data, error } = useData();
    const homePageData = getPageData(data, 'HomePageData');

    useEffect(() => {
        scrollVisibility()
        const handleResize = () => {
            setIsmobile(window.innerWidth < 700);
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener("scroll", scrollVisibility)
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener("scroll", scrollVisibility);
        };
    }, []);

    const scrollVisibility = (): void => {
        const scrollBtn = document.querySelector("#scroll-btn") as HTMLElement | null;
        const scrollY: number = window.scrollY;
        const viewHeight: number = window.innerHeight;
        const isScrollable: boolean = scrollY > viewHeight / 2;

        if (scrollBtn) {
            scrollBtn.style.display = isScrollable ? "flex" : "none";
        }
    };

    const scrollToTopFunction = async () => {
        const vhInPx = window.innerHeight;
        controls.set({ backgroundColor: 'rgba(0, 0, 0, 0)' });
        // Scroll to top after animation starts
        window.scrollTo({ top: 0, behavior: 'smooth' });
        await controls.start({
            y: -vhInPx * 0.95,
            opacity: 0,
            transition: { duration: 0.75, ease: 'easeIn' },
        });


        // Reset position and opacity after a short delay
        setTimeout(() => {
            controls.set({ y: 0, opacity: 1, backgroundColor: 'var(--color-primary)', });
        }, 1000);
    };

    return (
        <div className='relative md:pt-32'>
            {!ismobile && footerContactInfo && <FooterContactInfo homePageData={homePageData} />}
            <div className='flex flex-col text-white mt-auto'>
                <div className="bg-[#202D46] p-10 md:pt-28 relative">
                    <div className='flex flex-col md:flex-row gap-[20px] items-start justify-center md:justify-evenly md:items-start'>
                        <div className='flex flex-col gap-2 max-w-[280px]'>
                            <img src={images.LOGOLIGHT} className='w-48' alt='logo' />
                            <span className=' leading-[24px] md:leading-[33px] mt-2 text-wrap'>
                                We build the systems that let your team scale without breaking.
                            </span>
                            <div className='flex gap-2 mt-[20px] md:mt-[30px]'>
                                <a href='https://www.instagram.com/sattvatech/' target='_blank' rel="noreferrer" className='rounded-[50%] cursor-pointer flex items-center justify-center border-[1px] border-[#D3D3D3] w-[40px] h-[40px] md:w-[50px] md:h-[50px]'>
                                    <img src={INSTAGRAM} alt="instagram" />
                                </a>
                                <a href='https://www.linkedin.com/company/sattva-tech/' target='_blank' rel="noreferrer" className='rounded-[50%] cursor-pointer flex items-center justify-center border-[1px] border-[#D3D3D3] w-[40px] h-[40px] md:w-[50px] md:h-[50px]'>
                                    <img src={LINKEDIN} alt="linkedin" />
                                </a>
                                {/* <a href='' target='_blank' rel="noreferrer" className='rounded-[50%] cursor-pointer flex items-center justify-center border-[1px] border-[#D3D3D3] w-[40px] h-[40px] md:w-[50px] md:h-[50px]'>
                                    <img src={TWITTER} alt="twitter" />
                                </a> */}
                            </div>
                        </div>

                        <div className='flex flex-col gap-1 w-full md:w-auto'>
                            <div className='flex justify-between items-center w-full'>
                                <div className='font-[700] md:mb-5 leading-[24px] md:leading-[28px] text-[18px] md:text-[22px]'>
                                    Useful Links
                                </div>
                                <div className='text-white text-[45px] leading-[57px] font-[700] md:hidden' onClick={() => { setLink(!link) }}>+</div>
                            </div>
                            {ismobile ? (
                                link && (<>
                                    {/* <a href='/about-us' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                        About us
                                    </a> */}
                                    <a href='/portfolio' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                        Case Studies
                                    </a>
                                    {/* <a href='/gallery' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                        Gallery
                                    </a> */}
                                </>)
                            ) : (
                                <>
                                    {/* <a href='/about-us' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                        About us
                                    </a> */}
                                    <a href='/portfolio' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                        Case Studies
                                    </a>
                                    {/* <a href='/gallery' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                        Gallery
                                    </a> */}
                                </>
                            )}
                        </div>

                        <div className='flex flex-col gap-1 w-full md:w-auto'>
                            <div className='flex justify-between items-center w-full'>
                                <div className='font-[700] md:mb-5 leading-[24px] md:leading-[28px] text-[18px] md:text-[22px]'>
                                    Tech Services
                                </div>
                                <div className='text-white text-[45px] leading-[57px] font-[700] md:hidden' onClick={() => { setServices(!services) }}>+</div>
                            </div>
                            {ismobile ? (
                                services && (
                                    <>
                                        <a href='/biteu' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                            Financial Software
                                        </a>
                                        <a href='/ios' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                            App Development
                                        </a>
                                        <a href='/service' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                            Software Development
                                        </a>
                                        <a href='/ecc' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                            Healthcare/Medical Software
                                        </a>
                                        <a href='/aichat' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                            AI Solutions
                                        </a>
                                        <a href='/biteuweb' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                            Web Development
                                        </a>
                                    </>
                                )
                            ) : (
                                <>
                                    <a href='/biteu' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                        Financial Software
                                    </a>
                                    <a href='/ios' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                        App Development
                                    </a>
                                    <a href='/service' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                        Software Development
                                    </a>
                                    <a href='/ecc' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                        Healthcare/Medical Software
                                    </a>
                                    <a href='/aichat' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                        AI Solutions
                                    </a>
                                    <a href='/biteuweb' className=' leading-[28px] md:leading-[33px] text-[14px] md:text-[16px] cursor-pointer'>
                                        Web Development
                                    </a>
                                </>
                            )}
                        </div>

                        <div className='flex flex-col gap-2'>
                            <span className='font-[700] mb-2 md:mb-5 leading-[24px] md:leading-[28px] text-[18px] md:text-[22px]'>
                                Contact info
                            </span>
                            <div className='flex gap-2 md:gap-3 items-center'>
                                <img src={CALL} className='animate-pulse' alt='call' />
                                <a className='font-medium hover:text-yellow cursor-pointer leading-[28px] md:leading-[33px] text-[14px] md:text-[16px]' href={`tel:${homePageData.company_number}`}>
                                    {homePageData.company_number}
                                </a>
                            </div>
                            <div className='flex gap-2 md:gap-3 items-center'>
                                <img src={EMAIL} alt='mail' className='animate-pulse' />
                                <div className='font-medium hover:text-yellow cursor-pointer leading-[28px] md:leading-[33px] text-[14px] md:text-[16px]' onClick={() => { window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${homePageData.company_email}`) }}>
                                    {homePageData.company_email}
                                </div>
                            </div>
                            <div className='flex gap-2 md:gap-3 items-start max-w-[350px]'>
                                <img src={LOCATION} className='animate-pulse' alt='address' />
                                <span className='font-medium leading-[28px] md:leading-[33px] text-[14px] md:text-[16px]'>
                                    {homePageData.company_address}
                                </span>
                            </div>
                            <div className='flex gap-2 md:gap-3 items-start max-w-[350px]'>
                                <img src={LOCATION} className='animate-pulse' alt='address' />
                                <span className='font-medium leading-[28px] md:leading-[33px] text-[14px] md:text-[16px]'>
                                    {homePageData.company_address_2}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className='items-end md:items-center justify-end mt-5 md:mt-0 fixed bottom-10 right-10 z-50 transition-opacity duration-500' id="scroll-btn">
                        <motion.div
                            className="flex items-center justify-center w-[50px] h-[50px] md:w-[66px] md:h-[66px] bg-[var(--color-primary)] rounded-full cursor-pointer"
                            onClick={scrollToTopFunction}
                            animate={controls}
                            id="myBtn"
                        >
                            <motion.img
                                animate={{ y: [0, -10, 0] }}
                                transition={{ repeat: Infinity, duration: 1 }}
                                src={SCROLLTOP}
                                alt="scrollIcon"
                            />
                        </motion.div>
                    </div>
                </div>
                <div className='h-14 bg-[var(--color-primary)] text-white flex justify-center items-center text-center'>
                    <img src={COPYRIGHT} alt='copyRight' />
                    <p className='font-bold text-sm ml-2'>
                        2026 SATTVATECH | All rights reserved
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Footer;